import { appLifecycleListeners } from "./webAppLifecycleListeners";
import webosKit from "../libs/webOSTVjs-1.2.0/webOSTV";
import isBrowser from "../../../utils/isBrowser";
function isApplicationEventSupported(event) {
  if (!appLifecycleListeners[event]) {
    console.error(
      // TODO consider moving this string to the errors file
      `The application doesn't support ${event} lifecycle event.`
    );
    return false;
  }
  return true;
}

function bindEvents() {
  isBrowser &&
    window.document &&
    document.addEventListener &&
    document.addEventListener(
      "visibilitychange",
      function() {
        appLifecycleListeners.visibilitychange.forEach(listener => listener());
      },
      false
    );

  document.addEventListener(
    "cursorStateChange",
    function(event) {
      appLifecycleListeners.isMagicRemoteActive = event.detail.visibility;
    },
    false
  );
}

bindEvents();
export const application = {
  async exit() {
    webOS.platformBack();
  },
  // FIXME the on and off methods are repeated in the network and player (tizen). Given tha the logic is the same, we should create a common utility module.
  on(event, listener) {
    if (isApplicationEventSupported(event)) {
      appLifecycleListeners[event].push(listener);
    }
  },
  off(event, listener) {
    if (isApplicationEventSupported(event)) {
      const listenerIndex = appLifecycleListeners[event].findIndex(existingListener => existingListener === listener);
      appLifecycleListeners[event].splice(listenerIndex, 1);
    }
  },
  getDeepLinkTitle() {
    return "";
  },
  checkMagicRemote() {
    return appLifecycleListeners.isMagicRemoteActive;
  }
};
